import React from "react";
import { Link } from "react-router-dom";
import { ShieldCheck, ArrowLeft } from "@phosphor-icons/react";
import { AppFrame } from "../components/Layout";
import { PRIVACY_SECTIONS } from "../data/staticData";

export default function PrivacyPolicy() {
  return (
    <AppFrame>
      <div className="px-6 pb-16">
        <div className="flex items-center gap-3 pt-7">
          <Link
            to="/"
            data-testid="privacy-home-link"
            className="flex h-10 w-10 items-center justify-center rounded-full bg-white shadow-sm"
          >
            <ArrowLeft size={20} color="#36302B" />
          </Link>
          <h1 className="font-display text-3xl font-medium text-[#36302B]">Confidentialité</h1>
        </div>

        <div className="mt-5 flex items-start gap-3 rounded-3xl bg-[#9CAEA9]/12 p-5">
          <ShieldCheck size={22} color="#88A096" weight="duotone" className="mt-0.5 shrink-0" />
          <p className="text-[14px] leading-relaxed text-[#36302B]/75">
            Renaître est pensée comme un refuge. Voici, en toute transparence, comment vos données sont protégées.
          </p>
        </div>

        <div className="mt-4 space-y-3">
          {PRIVACY_SECTIONS.map((s, i) => (
            <div key={i} className="rounded-3xl border border-[#36302B]/6 bg-white p-5">
              <h2 className="font-display text-[16px] font-medium text-[#36302B]">{s.title}</h2>
              <p className="mt-2 text-[13.5px] leading-relaxed text-[#36302B]/70">{s.body}</p>
            </div>
          ))}
        </div>

        <p className="mt-6 text-center text-[11.5px] leading-relaxed text-[#36302B]/45">
          Sources : RGPD Articles 9 & 17, CNIL (données de santé), Loi Informatique et Libertés (2018).
        </p>
        <Link to="/mentions-legales" className="mt-4 block text-center text-[13px] font-bold text-[#C57B67]">
          Voir les mentions légales →
        </Link>
      </div>
    </AppFrame>
  );
}
